// ★ [spec-002 T051b/MUST-1, review PR #2328] Carimba `fontes_web` na mensagem
// AO VIVO, no `end` do turno — sem isto o cartão de fonte web (T050/T051)
// some ANTES do F5: `resetChatState` zera o canal transiente `buscaStreaming`
// no INÍCIO do turno seguinte (`store/actions.js::resetCanaisDoAgente`), e a
// mensagem já gravada no Vuex nunca foi atualizada com o dado — o cartão
// desaparece assim que o consultor manda a PRÓXIMA pergunta, mesmo sem sair
// da tela. `GET /messages` (backend, `resource_messages.py`) resolve o F5;
// isto aqui resolve a sessão contínua.
//
// Mesma regra de dedupe do componente (`chat-message-fontes-web.vue::
// citacoesBrutas`/`fontes`): a PRIMEIRA ocorrência da URL vence (é a que o
// consultor viu aparecer), e o `coletado_em` de cada fonte cai para o do
// EVENTO quando a fonte não traz o próprio — nunca inventado aqui.

/**
 * Deduplica as fontes web coletadas durante o turno (canal `buscaStreaming`)
 * no MESMO shape que o backend persiste em `fontes_web`
 * (`_fontes_web_apoio.fontes_web_dos_eventos_busca`): uma citação crua por
 * URL, com `url`/`titulo`/`dominio`/`coletado_em`.
 *
 * @param {Array} buscaStreaming eventos do canal (`store/getters.js::buscaStreaming`).
 * @returns {Array} citações cruas, deduplicadas por URL.
 */
export function fontesWebDoTurno(buscaStreaming) {
  const eventos = Array.isArray(buscaStreaming) ? buscaStreaming : []
  const vistas = {}
  const lista = []
  eventos.forEach((evento) => {
    const fontesDoEvento = (evento && evento.fontes) || []
    fontesDoEvento.forEach((fonte) => {
      const url = fonte && typeof fonte.url === 'string' ? fonte.url.trim() : ''
      if (!url || vistas[url]) return
      vistas[url] = true
      lista.push({
        url: url,
        titulo: (fonte && fonte.titulo) || null,
        dominio: (fonte && fonte.dominio) || null,
        coletado_em: (fonte && fonte.coletado_em) || (evento && evento.coletado_em) || null,
      })
    })
  })
  return lista
}
